import { AsyncPipe } from '@angular/common';
import { Component, input, OnDestroy, OnInit, output } from '@angular/core';
import { interval, map, Observable, Subject, take } from 'rxjs';

const FIVE_MINUTES_IN_SECONDS = 300;
const ONE_SECOND_IN_MS = 1000;
const SECONDS_IN_MINUTE = 60;
const SECONDS_DISPLAY_LENGTH = 2;

@Component({
  selector: 'app-otp-countdown',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './otp-countdown.component.html',
  styleUrl: './otp-countdown.component.scss'
})
export class OtpCountdownComponent implements OnInit, OnDestroy {
  durationInSeconds = input<number>(FIVE_MINUTES_IN_SECONDS); // 5 MINUTES
  isCountdownFinished = output<boolean>();

  private readonly destroy$ = new Subject<void>();
  countdown$: Observable<string> | undefined;

  ngOnInit(): void {
    this.countdown$ = interval(ONE_SECOND_IN_MS)
    .pipe(
      take(this.durationInSeconds()),
      map(value => {
        const MINUTES = Math.floor((this.durationInSeconds() - value) / SECONDS_IN_MINUTE);
        const SECONDS = (this.durationInSeconds() - value ) % SECONDS_IN_MINUTE;

        return `${MINUTES}:${SECONDS.toString().padStart(SECONDS_DISPLAY_LENGTH, '0')}`;
      })
    );

    this.countdown$.subscribe({
      complete: () => {
        this.isCountdownFinished.emit(true);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
